import Switch from './_switch';

export default Switch;
